import Vue from "vue";
import { isError } from "lodash";
import { basicAccountInfoManager } from "../Account/basicAccountInfoManager";

function newContainer() {
  const d = document.createElement("div");
  // eslint-disable-next-line compat/compat
  document.body.appendChild(d);
  return d;
}

const $doc = $(document);
export function setUpTopicPost(): () => JQuery {
  async function onClick(this: HTMLElement) {
    const res = await basicAccountInfoManager.proceedAfterLogin();
    const container = newContainer();
    if (!isError(res)) {
      const TopicPost = () => import(/* webpackChunkName: "TopicPost" */ "./CreateTopicPost.vue");
      new Vue({
        render: (h) => h(TopicPost),
      }).$mount(container);
    } else {
      console.error(res.message);
    }
  }
  $doc.on("click", ".js-open-topicpost-modal", onClick);
  return () => $doc.off("click", ".js-open-topicpost-modal", onClick);
}
